import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { WidgetSilkBox } from 'src/domains/sportsbook/webview/components/nextRaces/raceBoxSelection/WidgetSilk.style';

interface WidgetSilkPropsType {
    selectionId: SelectionId;
}

export const WidgetSilk = observer('WidgetSilk', (props: WidgetSilkPropsType) => {
    const { selectionId } = props;
    const selection = selectionId.getModel();
    const market = selection?.marketId2.getModel() ?? null;

    if (selection === null || market === null) {
        return null;
    }

    if (market.isOutright === false) {
        return null;
    }

    const silkAltDesc = selection.metaDataSilk ?? '';
    const silkUrl = selection.metaDataSilkUrl ?? '';

    return (
        <WidgetSilkBox
            alt={silkAltDesc}
            imgBase={{
                src: silkUrl,
                optimizeOptions: {
                    quality: 85,
                    width: 54,
                },
            }}
        />
    );
});
